import { Menu } from '@chakra-ui/react';
import React, { useMemo } from 'react';
import FilterColumnMenuContent from './FilterColumnMenuContent';
const mapHeadersToSelectOptions = (headers) => [
    {
        selectedValues: headers
            .filter((header) => header.isSelected)
            .map((header) => header.key),
        items: headers.map((header) => ({
            title: header.title,
            value: header.key,
            isDisabled: header.isDisabledInColumnMenu ?? false,
        })),
    },
];
const FilterColumnMenu = ({ headers, ...rest }) => {
    const selectOptions = useMemo(() => mapHeadersToSelectOptions(headers), [headers]);
    return (React.createElement(Menu, { closeOnSelect: false, variant: "multi-select-thin" },
        React.createElement(FilterColumnMenuContent, { selectOptions: selectOptions, ...rest })));
};
export default FilterColumnMenu;
